<template>
  <div class="modal modalFade userModels userRegisterModal" id="user_register" tabindex="-1"
    aria-labelledby="userModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="backBtn" @click="toggleModal('userModal')">
            <i class="fi-rr-angle-right"></i>
          </button>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="icon_wrap">
            <svg id="user_linear" data-name="user/linear" xmlns="http://www.w3.org/2000/svg" width="30" height="30"
              viewBox="0 0 24 24">
              <g id="vuesax_linear_user" data-name="vuesax/linear/user">
                <g id="user">
                  <path id="Vector" d="M10,5A5,5,0,1,1,5,0,5,5,0,0,1,10,5Z" transform="translate(7 2)" fill="none"
                    stroke="#292d32" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                  <path id="Vector-2" data-name="Vector" d="M17.18,7c0-3.87-3.85-7-8.59-7S0,3.13,0,7"
                    transform="translate(3.41 15)" fill="none" stroke="#292d32" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="1.5" />
                  <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0" />
                </g>
              </g>
            </svg>
          </div>
          <h3 class="icon_title">تسجيل جديد</h3>
          <form @submit.prevent="handleSubmit">

            <div class="input-group">
              <input
                type="text"
                id="register_name"
                name="register_name"
                placeholder="ادخل الاسم"
                class="form-control"
                v-model="registerName"
                :class="{ 'is-invalid': nameError }"
                autofocus
              />
              <span v-if="nameError" class="has-error text-danger w-100">{{ nameError }}</span>
            </div>
            <div class="input-group"></div>
            <div class="input-group">

              <button
                type="submit"
                class="form-control has-spinner-link"
                :class="{ 'loading': isLoading }"
                :disabled="isLoading"
              >
                <div class="button_text">

                  تسجيل
                            
                </div>
              </button>
            </div>
            <div class="input-group">
              <p class="agree-terms">
                      بالتسجيل أنت توافق على
                     
                
                    <NuxtLink :to="`/privacy`" target="_blank">
                      الشروط والأحكام و سياسة الخصوصية 
                    </NuxtLink>
                   
                      
                  </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useAuthStore } from '@/store/auth';
import { useBootstrapModal } from '@/composables/useBootstrapModal';
import { useAuth } from '@/composables/useAuth';
import { useRoute } from 'vue-router';


const { updateUserName } = useAuth();

const authStore = useAuthStore();
const { openModal: openRegistrationModal, closeModal: closeRegistrationModal } = useBootstrapModal('user_register');


const registerName = ref('');       // For the name input
const nameError = ref('');          // For validation errors
const isLoading = ref(false);       // For loading state

const route = useRoute();


// Event handler for modal hidden event
let handleHidden = () => {
  if (!authStore.user?.name) {
    openRegistrationModal();
  }
};

onMounted(() => {

  // If current route is /privacy, do not show the modal
  if (route.path === '/privacy') return;

  // Open modal if name is missing on component mount
  if (authStore.user && !authStore.user?.name) {
    openRegistrationModal();
  }

  // Add event listener to modal's hidden event
  const modalElement = document.getElementById('user_register');
  if (modalElement) {
    modalElement.addEventListener('hidden.bs.modal', handleHidden);

    // Cleanup on component unmount
    onUnmounted(() => {
      modalElement.removeEventListener('hidden.bs.modal', handleHidden);
    });
  }
});




const handleSubmit = async () => {
  if (!registerName.value.trim()) {
    nameError.value = 'الرجاء ادخال الاسم';
    return;
  }

  const nameParts = registerName.value.trim().split(/\s+/);
  if (nameParts.length < 2) {
    nameError.value = 'الرجاء ادخال الاسم الأول والأخير';
    return;
  }

  nameError.value = '';
  isLoading.value = true;
  
  try {
    const success = await updateUserName(registerName.value);
    if (success) {
      closeRegistrationModal();
    }
  } finally {
    isLoading.value = false;
  }

};

const closeModal = () => {
  closeRegistrationModal();
  if (!authStore.user?.name) {
    openRegistrationModal();
  }
};
</script>